<script>
  import { link } from "svelte-routing";

  let className = "";
  export { className as class };
  export let target = null;
  export let href = null;
  export let style = null;
  export let onClick = null;
</script>

{#if onClick}
  <a
    class="report-button {className}"
    {style}
    {href}
    on:click|preventDefault={onClick}
  >
    <slot />
  </a>
{:else}
  <a class="report-button {className}" {style} {href} {target} use:link>
    <slot />
  </a>
{/if}

<style lang="scss">
  .report-button {
    border: 1px solid rgba(101, 150, 184, 0.6);
    border-radius: 6px;
    cursor: pointer;
    padding: 13px 18px 15px;
    color: #006b97;
    background-color: white;
    font-family: "Segoe UI", sans-serif;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500; //figma says 600, but looks more proper with 500 (because Segoe UI not Avenir)

    display: inline-flex;
    align-items: center;
    gap: 10px;

    &:hover,
    &:focus {
      color: white;
      background-color: #00354b;
    }

    &.blue {
      color: white;
      background-color: #006b97;

      &:hover,
      &:focus {
        background-color: #00354b;
      }
    }

    &.orange {
      color: white;
      background-color: #d07743;
      border-color: #d07743;

      &:hover,
      &:focus {
        background-color: darken(#d07743, 5%);
      }
    }
  }
</style>
